import { SVGLens as SVGLensComponent } from "@/lib/svg";
import styled from "styled-components";

// Cast to fix React 17 + @types/react 18 compatibility issue
const SVGLens = SVGLensComponent as any;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.darkMiddle};
`;

export const Label = styled.span`
  font-family: ${({ theme }) => theme.fontFamilies.secondary};
  font-weight: 400;
  font-size: 1.25rem;
`;

export const Icon = styled(SVGLens as any)`
  width: 1rem;
  position: relative;
  top: 0.1rem;
`;
